import React from "react";
import { connect } from "react-redux";
import { SettingsMenuItem } from "./SettingsMenuItem";
import { SettingsMenuSection } from "./SettingsMenuSection";
import { SettingsMenuList } from "./SettingsMenuList";
import { SettingsMenuTitle } from "./SettingsMenuTitle";
import getTextTrackLanguages from "../../../selectors/captions/getTextTrackLanguages";
import * as CaptionActions from "../../../actions/CaptionActions";

export const CaptionsMenu = connect(
  (state, ownProps) => {
    const textTrackLanguages = getTextTrackLanguages(state, ownProps);
    return {
      textTrackLanguages,
      textTrackLanguage: state.captions.textTrackLanguage,
    };
  },
  (dispatch) => ({
    setTextTrackLanguage: (language) =>
      dispatch(CaptionActions.setTextTrackLanguage(language)),
  }),
  undefined,
  { pure: false },
)(({ setTextTrackLanguage, textTrackLanguage, textTrackLanguages }) =>
  textTrackLanguages.length ? (
    <SettingsMenuSection
      title={
        <SettingsMenuTitle data-captions-title icon="icon-Closed-Captions">
          Captions
        </SettingsMenuTitle>
      }
      data-speed-menu
    >
      <SettingsMenuList>
        <SettingsMenuItem
          data-language="off"
          active={!textTrackLanguage}
          icon={!textTrackLanguage ? "x" : ""}
          onClick={() => setTextTrackLanguage("")}
        >
          Off
        </SettingsMenuItem>
        {textTrackLanguages.map(({ srclang }) => (
          <SettingsMenuItem
            data-language={srclang}
            key={srclang}
            icon={textTrackLanguage === srclang ? "x" : ""}
            onClick={() => setTextTrackLanguage(srclang)}
          >
            {/* Translate to human-readable if we can, otherwise just display the original. */}
            {typeof Intl.DisplayNames !== "undefined"
              ? new Intl.DisplayNames(["en"], { type: "language" }).of(srclang)
              : srclang}
          </SettingsMenuItem>
        ))}
      </SettingsMenuList>
    </SettingsMenuSection>
  ) : null,
);
